import React from 'react'
import { Col, Row, Container, Alert } from 'react-bootstrap'
import { BrowserRouter } from "react-router-dom";
import { AuthenticatedTemplate } from '@azure/msal-react'
import { useSelector } from 'react-redux'

import SideBar from '../components/Sidebar'
import AppRoutes from '../AppRoutes'
import Footer from "../components/Footer";
import Header from "../components/Header";
import ErrorPage from "../pages/ErrorPage"

function Template() {

    const { error, errorMessage } = useSelector((state) => state.user);

    // Detect the 404 "User not found" scenario
    const isUserNotFoundError = error && errorMessage?.includes("User not found");

    return (
        <BrowserRouter>
            {/* Show Header only if it's not a 404 error */}
            {!isUserNotFoundError && <Header />}

            <main className='py-3 my-2'>
                <Container>
                    {isUserNotFoundError ? (
                        // If it's 404, show only ErrorPage
                        <ErrorPage message={errorMessage} />
                    ) : (
                        // Normal app layout when no 404
                        <Row>
                            <Col sm={3}>
                                <AuthenticatedTemplate>
                                    <SideBar />
                                </AuthenticatedTemplate>
                            </Col>
                            <Col>
                                {/* Show alert only for non-404 errors */}
                                {error && !isUserNotFoundError && (
                                    <Alert variant='danger' dismissible className='ms-auto'>
                                        {errorMessage}
                                    </Alert>
                                )}

                                <AppRoutes />
                            </Col>
                        </Row>
                    )}
                </Container>
            </main>

            {/* Show footer only if not 404 */}
            {!isUserNotFoundError && <Footer />}
        </BrowserRouter>
    );
}

export default Template;
